import styled from "styled-components";

export const StyledMainPage = styled.div`
  background-color: ${(props) => props.theme.primaryBackground};
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;
export const MainPageSubContainer = styled.div`
  display: flex;
  height: calc(100vh - 50px);
  overflow: hidden;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .MuiTabs-root {
    background-color: ${(props) => props.theme.secondaryBackground || '#1e1e1e'};
    min-height: 60px;
  }

  .MuiTabs-flexContainer {
    justify-content: center;
  }

  .MuiTab-root {
    color: ${(props) => props.theme.secondaryText || '#999'};
    text-transform: none;
    font-size: 16px;
    font-weight: 600;
    min-width: 160px;
    padding: 12px 24px;
    transition: all 0.3s ease;
  }

  .MuiTab-root:hover {
    color: ${(props) => props.theme.primaryText || '#fff'};
    background-color: rgba(255, 255, 255, 0.05);
  }

  .MuiTab-root.Mui-selected {
    color: ${(props) => props.theme.primaryText || '#fff'};
    font-weight: 700;
  }

  .MuiTabs-indicator {
    background-color: ${(props) => props.theme.accentColor || '#2196f3'};
    height: 3px;
  }
`;
